import { useQuery } from '@tanstack/react-query';
import { Permit, PermitType, SiteMini, page } from '@cloudsign/shared';
import type { SiteMini as Site } from '@cloudsign/shared';
import { z } from 'zod';
import { api } from '../../lib/api';

export const PermitTypeList = z.array(PermitType);
export const SitePage = page(SiteMini);
export type PermitStatusKey = Permit['status'];

export const permitsKey = ['permits'] as const;
export const typesKey = ['permits', 'types'] as const;

export function usePermitTypes() {
  return useQuery({ queryKey: typesKey, queryFn: () => api.get('/permits/types', { schema: PermitTypeList }) });
}

/** Active sites for the filters and the raise form (the server limits what each person can raise at). */
export function usePermitSites() {
  return useQuery({
    queryKey: ['permits', 'sites'],
    queryFn: () => api.get('/sites', { query: { status: 'active', pageSize: 200 }, schema: SitePage }).then((r): Site[] => r.items),
    staleTime: 60_000,
  });
}

/** A `datetime-local` value (wall clock in the browser) to an ISO instant. */
export function localToIso(value: string): string {
  return new Date(value).toISOString();
}

/** An ISO instant to a `datetime-local` value. */
export function isoToLocal(iso: string): string {
  const d = new Date(iso);
  const p = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
}

export const slugId = (text: string, taken: readonly string[]): string => {
  const base = text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 24) || 'item';
  let id = base;
  for (let n = 2; taken.includes(id); n++) id = `${base}-${n}`;
  return id;
};
